<template>
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="v-icon-fill-color"
      d="M8.00391 13C8.55619 13 9.00391 12.5523 9.00391 12C9.00391 11.4477 8.55619 11 8.00391 11C7.45162 11 7.00391 11.4477 7.00391 12C7.00391 12.5523 7.45162 13 8.00391 13Z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M6.5 3.57713C7.453 2.71713 9.518 2.73213 9.923 4.21213C10.453 6.13413 8 6.14213 8 9.00013" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
